
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
      default: "Gender",
    },
    formProp: {
      type: String,
      required: true,
      default: "gender",
    },
    modelValue: {
      type: String,
      required: true,
      default: "",
    },
    placeHolder: {
      type: String,
      required: false,
      default: "",
    },
    tooltipMessage: {
      type: String,
      required: false,
      default: "",
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    isTooltip: {
      type: Boolean,
      required: false,
      default: false,
    },
    dropdown: {
      type: Array,
      required: false,
      default: null,
    },
  },

  setup(_, context) {


    const updateValue = (event) => {
      context.emit("update:modelValue", event);
      context.emit("change", event);
    };

    const gender = ref()
    const focus = () => {
      setTimeout(() => {
        gender.value.focus()
      }, 500);
    }

    const colSize = (_.formProp == 'gender_id') ? 'col-lg-12' : 'col-lg-12';

    return {
      gender,
      colSize,
      focus,
      updateValue,
    };
  },
});
